import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DEFAULT_IMG_PATH } from './file-upload-constant';
import { Subscription } from 'rxjs';
import { ReactiveFormService } from '../../services/reactive-form.service';


@Component({
    selector: 'kt-input-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit, OnDestroy {
    @ViewChild('fileInput', { read: true, static: false }) fileInput: ElementRef;

    @Input() fieldObj: any;
    @Input() options;
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();
    imagePreview;
    defaultIcon = this.sanitizer.bypassSecurityTrustResourceUrl(DEFAULT_IMG_PATH.Path);

    isHideExpression = false;
    subscriptions: Subscription[] = [];

    constructor(
        public sanitizer: DomSanitizer,
        public formService: ReactiveFormService,
        private cd: ChangeDetectorRef) { }

    ngOnInit() {
        this.setValidations();
        this.hideExpression();
    }

    fileChange(event: any) {
        const self = this;
        if (event.target.files && event.target.files[0]) {
            const fileList: FileList = event.target.files;
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (file: any) => {
                self.imagePreview = self.sanitizer.bypassSecurityTrustResourceUrl(file.target.result);
                this.cd.markForCheck();
            };
        }
        this.resetImgTag();
    }


    hideExpression() {
        if (this.fieldObj && this.fieldObj.hideExpression && this.fieldObj.hideExpression.fieldName) {
            this.clearValidations();
            this.subscriptions.push(this.form.controls[this.fieldObj.hideExpression.fieldName].valueChanges.subscribe(val => {
                if (this.fieldObj.hideExpression.fieldValue === this.formService.matchValueExpression(val)) {
                    this.isHideExpression = false;
                    this.setValidations();
                } else {
                    this.clearValidations();
                }
            }));
        }
    }

    setValidations() {
        this.form.controls[this.fieldObj.key].validator =
            Validators.compose([this.fieldObj.required ? Validators.required : null]);
    }

    clearValidations() {
        this.isHideExpression = true;
        this.form.controls[this.fieldObj.key].clearValidators();
        this.form.controls[this.fieldObj.key].updateValueAndValidity();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    notifyChange() {
        if (this.form && this.fieldObj.key && this.form.controls[this.fieldObj.key].value) {
            this.valueChange.emit({ key: this.fieldObj.key, value: this.form.controls[this.fieldObj.key].value });
        }
    }

    resetImage() {
        this.imagePreview = null;
        this.resetImgTag();
    }

    resetImgTag() {
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
    }

}
